export const PageHeader = ({ eyebrow, title, description }) => {
  return (
    <section
      data-testid="page-header"
      className="relative bg-gradient-to-br from-blue-50 via-white to-slate-50 pt-14 md:pt-24 pb-14 md:pb-20 overflow-hidden"
    >
      <div className="absolute inset-0 pointer-events-none opacity-70">
        <div className="absolute -top-24 -right-24 h-80 w-80 rounded-full bg-blue-200/40 blur-3xl" />
      </div>
      <div className="relative max-w-5xl mx-auto px-6 md:px-10">
        {eyebrow && (
          <div className="text-xs uppercase tracking-[0.22em] font-semibold text-blue-700">
            {eyebrow}
          </div>
        )}
        <h1 className="mt-4 font-serif text-4xl sm:text-5xl lg:text-6xl leading-[1.05] tracking-tight text-slate-900">
          {title}
        </h1>
        {description && (
          <p className="mt-5 text-lg text-slate-600 leading-relaxed max-w-3xl">
            {description}
          </p>
        )}
      </div>
    </section>
  );
};

export default PageHeader;
